export const appSolutionOptions = [
  { name: 'Intergy', value: 'Intergy' },
  { name: 'Prime Suite', value: 'Prime Suite' },
];
